define('lib/validator/ValidatorDigitsOnly',['require','lib/validator/ValidatorAbstract'],function (require) {

    var ValidatorAbstract = require('lib/validator/ValidatorAbstract');

    return ValidatorAbstract.extend({
        options : {
            withMinus : false,
            error : 'error_value_is_not_digits',
        },
        /**
         * Validates value
         *
         * @param mixed value
         */
        validate: function (value) {
            var regexp = /^[0-9]+$/;

            if(this.options.withMinus){
                regexp = /^[0-9\-]+$/;
            }
            if (!_.isEmpty(value) && !regexp.test(value)) {
                this.addError(this.options.error);
            }
        }

    });

});
